import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import AdminCommonSection from '../components/adminLayout';
import { KeolisSpinner} from './common/commonExport';

var selectedFile = null;
var fileList = [];

var punchInFile = null;
var releaseFile = null;
var paycodeFile = null;
var markOffsFile = null;
var guaranteeFile = null;
var scheduleFile = null;

class HastusToTCE extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            punchIn_File: false,
            release_File: false,
            paycode_File: false,
            markOffs_File: false,
            guarantee_File: false,
            schedule_File: false,
            showSpinner: false
        }
    }
    componentDidMount(){
    }
    
    onFileChange(event) {
        
        var fileName = event.target.files[0].name
        switch(event.target.id){
            case "PunchIn-Out":
                if(fileName.toLowerCase().indexOf("punch") == -1)
                {
                    alert("Please upload the correct PunchIn-Out file with the filename has word'Punch'");
                    event.target.value = null
                } else {
                    punchInFile = event.target.files[0]
                }
                break;
            case "Release":
                if(fileName.toLowerCase().indexOf("release") == -1)
                {
                    alert("Please upload the correct Release file with the filename has word 'Release'");
                    event.target.value = null
                } else {
                    releaseFile = event.target.files[0]
                }
                break;
            case "Paycode":
                if(fileName.toLowerCase().indexOf("paycode") == -1)
                {
                    alert("Please upload the correct Paycode file with the filename has word 'Paycode'");
                    event.target.value = null
                } else {
                    paycodeFile = event.target.files[0]
                }
                break;
            case "Markoffs":
                if(fileName.toLowerCase().indexOf("markoffs") == -1)
                {
                    alert("Please upload the correct Markoffs file with the filename has word 'Markoffs'");
                    event.target.value = null
                } else {
                    markOffsFile = event.target.files[0]
                }
                break;
            case "Guarantee": 
                if(fileName.toLowerCase().indexOf("guarantee") == -1)
                {
                    alert("Please upload the correct Guarantee file with the filename has word 'Guarantee'");
                    event.target.value = null
                } else {
                    guaranteeFile = event.target.files[0]
                }
                break;
        }
    }

    getSelectedFile(uploadedFileName){
        switch(uploadedFileName){
            case "PunchIn-Out":
                return punchInFile
            case "Release": 
                return releaseFile
            case "Paycode":
                return paycodeFile
            case "Markoffs":
                return markOffsFile
            case "Guarantee":
                return guaranteeFile
            case "Schedule":
                return scheduleFile
        }
    }

    onFileUpload(uploadedFileName){
        const formData = new FormData();
        selectedFile = this.getSelectedFile(uploadedFileName)
        fileList.push(selectedFile.name);
        if(selectedFile != null ) {
            formData.append("avatar", selectedFile);
            formData.append("name", selectedFile.name);
            formData.append("folderName", this.props.authDetails.name);
            var url = '/upload-avatar'
            fetch(url, {
                method: 'POST',
                body: formData
            })
            .then((response) => response.json())
            .then((data) => {
                switch (uploadedFileName) {
                    case "PunchIn-Out":
                        this.setState({
                            punchIn_File: true
                        })
                        break
                    case "Release":
                        this.setState({
                            release_File: true
                        })
                        break
                    case "Paycode":
                        this.setState({
                            paycode_File: true
                        })
                        break
                    case "Markoffs":
                        this.setState({
                            markOffs_File: true
                        })
                        break
                    case "Guarantee":
                        this.setState({
                            guarantee_File: true
                        })
                        break
                    case "Schedule":
                        this.setState({
                            schedule_File: true
                        })
                        break
                  }
            })
        }
    }

    deleteMyFiles(){
        setTimeout(() => {
            var name = this.props.authDetails.name
            var url = '/delete_hastusfile/'+name
            fetch(url, { method: 'GET'})
        }, 5000)
        
    }

    onFilesTransform(){
        
        if(this.state.punchIn_File 
            && this.state.release_File 
            && this.state.guarantee_File 
            && this.state.paycode_File 
            && this.state.markOffs_File
            ) 
             {
                this.setState({ showSpinner: true })
                this.resetInputValue();
                var foldername = this.props.authDetails.name
                var url = '/hastus_transform/'+foldername
                fetch(url, {
                    method: 'GET',
                })
                .then((response) => response.json())
                .then((data) => {
                    console.log("onFilesTransform : ", data)
                    alert("Transform Initiated, It will take a while to Complete")
                    this.setState({ showSpinner: false })
                })
            }
        else {
            alert("Upload all mandatory files")
        }
    }

    resetInputValue() {
        punchInFile = null;
        releaseFile = null;
        paycodeFile = null;
        markOffsFile = null;
        guaranteeFile = null;
        document.getElementById("PunchIn-Out").value = "";
        document.getElementById("Release").value = "";
        document.getElementById("Paycode").value = "";
        document.getElementById("Markoffs").value = "";
        document.getElementById("Guarantee").value = "";
        this.setState({
            punchIn_File: false,
            release_File: false,
            paycode_File: false,
            markOffs_File: false,
            guarantee_File: false,
            schedule_File: false,
            showSpinner: false
        });
    }

    createFileBrowserComponent(title) {
        if(title == "PunchIn-Out"){}
        return <tr style={{ border: 'solid thin' }}>
            <div style={{ padding: 10 }}>
                <div style={{ fontWeight: 600 }}> {title} </div>
                
                <input type="file" id={title} onChange={this.onFileChange} />
                <div style={{ paddingTop: 10, paddingRight: 10 }}>
                    <button onClick={() => this.onFileUpload(title)}> Upload </button>
                </div>
                {title == "PunchIn-Out" ? this.state.punchIn_File ? <div style={{color:'green'}}>File Uploaded</div> : <div/> : <div/>}
                {title == "Release" ? this.state.release_File ? <div style={{color:'green'}}>File Uploaded</div> : <div/> : <div/>}
                {title == "Paycode" ? this.state.paycode_File ? <div style={{color:'green'}}>File Uploaded</div> : <div/> : <div/>}
                {title == "Markoffs" ? this.state.markOffs_File ? <div style={{color:'green'}}>File Uploaded</div> : <div/> : <div/>}
                {title == "Guarantee" ? this.state.guarantee_File ? <div style={{color:'green'}}>File Uploaded</div> : <div/> : <div/>}
            </div>
            </tr>;
    }

    render() {
        let compTitle = 'HASTUS TO TCE';
        return (
            <AdminCommonSection compTitle={compTitle} admin={true}
            tblBody={
                <div>
                    <div id="tblMainActivities">
                        <table className="table table-striped table-bordered_header table-condensed">
                            <tbody>
                                {this.createFileBrowserComponent("PunchIn-Out")}
                                {this.createFileBrowserComponent("Release")}
                                {this.createFileBrowserComponent("Paycode")}
                                {this.createFileBrowserComponent("Markoffs")}
                                {this.createFileBrowserComponent("Guarantee")}
                                {/* {this.createFileBrowserComponent("Schedule")} */}
                                <tr>
                                    <td style={{padding:10, alignSelf:'center', alignItems:"center", 
                                    justifyContent:"center", alignContent:"center" }}>
                                        <button onClick={() => this.onFilesTransform()}> Transform </button>
                                    </td>
                                </tr>
                                {this.state.showSpinner ? <tr>
                                    <td>
                                    <KeolisSpinner />
                                    </td>
                                </tr>: <tr></tr>}
                            </tbody>
                        </table>
                        
                    </div>
                    
                </div>
            }/> 
            
        )
    }
}

function mapStateToProps(state) {
    return {
        isLoading: state.series.isLoading,
        authDetails:state.authState,
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(HastusToTCE);


// <div style={{flex:1, flexDirection: "column"}}>
            //         <input type="file" onChange={this.onFileChange}/>
            //         <button onClick={this.onFileUpload}>
            //             Upload
            //         </button>
            // </div>